import React, { useState } from "react";
import "./FAQ.css";

const faqs = [
  {
    question: "What is Farmology?",
    answer:
      "Farmology is a SaaS platform designed to revolutionize farm management by providing end-to-end solutions for farmers. It helps in crop management, financial planning, market access, and sustainability practices.",
  },
  {
    question: "How does Farmology help with farm management?",
    answer:
      "Farmology offers tools to monitor crop health, track weather conditions, schedule irrigation, manage financial records, and connect farmers to buyers, enabling better prices and streamlined operations.",
  },
  {
    question: "How accurate is your app in predicting farm data?",
    answer:
      "Our app uses advanced machine learning algorithms and real-time data from satellites, sensors, and weather stations to provide highly accurate predictions for crop health, weather forecasts, and soil conditions. This allows farmers to make informed decisions and reduce risk.",
  },
  {
    question: "How can farmers increase profitability using Farmology?",
    answer:
      "Farmology helps farmers increase profitability by optimizing resource usage, improving crop yields through data-driven insights, reducing costs via efficient farm management, and providing direct access to buyers for better prices. It also facilitates financial planning and record-keeping to maximize profits.",
  },
  {
    question: "How does Farmology support sustainability?",
    answer:
      "Farmology supports sustainability by promoting efficient resource management practices, such as optimized irrigation and soil conservation. It also offers tools for eco-friendly farming and access to sustainable farming techniques that reduce environmental impact while improving productivity.",
  },
  {
    question: "How can I get started with Farmology?",
    answer: (
      <>
        Getting started with Farmology is easy. Visit our website at{" "}
        <a
          href="https://farmology.ai/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Farmology.ai
        </a>
        , sign up for an account, and create your farm profile. From there, you
        can access our full range of features and tools, as well as real-time
        insights to manage your farm more efficiently.
      </>
    ),
  },
];

const FAQ = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((current) => (current === index ? null : index));
  };

  return (
    <div className="faq-container">
      <div className="faq-list">
        {faqs.map((faq, index) => {
          const isOpen = openFaq === index;

          return (
            <div
              className={`faq-item ${isOpen ? "open" : ""}`}
              key={faq.question}
            >
              <button
                type="button"
                className="faq-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={isOpen}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="faq-question-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="faq-question-text">{faq.question}</span>

                <span className="faq-toggle" aria-hidden="true">
                  {isOpen ? "−" : "+"}
                </span>
              </button>

              <div
                id={`faq-answer-${index}`}
                className="faq-answer"
                aria-hidden={!isOpen}
              >
                <div className="faq-answer-inner">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;
